// The per-step "Required" switch, the same row shape as "Use as score" but
// not exclusive: any number of steps can be required. The widget enforces
// it (no Skip, advance held until there is an answer); nothing server-side
// checks answers against it.

import { Switch } from "@pej/kore/components";

export interface RequiredToggleProps {
    checked: boolean;
    /** A split step only appears once the score is answered, so it is only
     *  required when it is shown; the copy says so. */
    splitByScore: boolean;
    onCheckedChange: (next: boolean) => void;
}

export function RequiredToggle({ checked, splitByScore, onCheckedChange }: RequiredToggleProps) {
    return (
        <div className="flex items-center justify-between gap-4 rounded-kore-md border border-kore-border p-3">
            <div>
                <p className="text-sm font-medium text-kore-text">Required</p>
                <p className="text-xs text-kore-text-muted">
                    {splitByScore
                        ? "When shown, respondents can't skip this step or move on without answering."
                        : "Respondents can't skip this step or move on without answering."}
                </p>
            </div>
            <Switch checked={checked} onCheckedChange={onCheckedChange} aria-label="Required" />
        </div>
    );
}
